import { MediaMatcher } from "@angular/cdk/layout";
import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, SimpleChanges, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { CallBackService } from "../../../../callback/services/CallBack.service";
import { TutorialService } from "../../tutorial/services/tutorial.service";
import { trigger, state, style, transition, animate } from "@angular/animations";
import { FormGroup } from "@angular/forms";
import { MatSidenav } from "@angular/material/sidenav";
import { firstValueFrom, Observable, Subscription, take } from "rxjs";
import { SignalUser } from "../../../models/SignalUser/SignalUser";
import { EncriptionService } from "../../../services/Encription.service";
import { PermissionsService } from "../../../services/ServiceCatalogEncapsulators/Permissions.service";
import { SignalUserService } from "../../../services/ServiceCatalogEncapsulators/Signal-User.service";
import { SessionService } from "../../../services/Session.service";
import { SignalRService } from "../../../services/Signal-R.service";
import { NavHeaderService } from "../../nav-menu/services/nav-header.service";
import { AuthService } from "src/app/features/authmanagement/services/Auth.service";
import { NotificationDTO } from "src/app/features/notifications/models/NotificationDTO";
import { NotificationService } from "src/app/features/notifications/services/Notification.service";
import { SwalNotificationService } from "../../../services/SwalNotification.service";
import { AlarmService } from "src/app/features/alarms/service/Alarm.service";
import { ImageCacheService } from "../../../services/ImageCache.service";
import { MatDialog } from "@angular/material/dialog";
import { LayerService } from "src/app/features/locations-map/services/Layers.service";
import { MapHelperService } from "src/services/map-helper.service";
import { ControlPanelService } from "src/app/features/main-dashboard/services/ControlPanel.service";
enum ROLES_APP {
  Admin = "Admin",
  User = "User",
  UserPrivileged = "UserPrivileged",
  Superuser = "Superuser",
}

@Component({
  selector: "nav-header",
  templateUrl: "./nav-header.component.html",
  styleUrls: ["./nav-header.component.css"],
  animations: [
    trigger("mostrarNotificaciones", [
      state("visible", style({ opacity: 1, height: "*" })),
      state("hidden", style({ opacity: 0, height: "0px", overflow: "hidden", display: "none" })),
      transition("visible <=> hidden", animate("300ms ease-in-out")),
    ]),
  ],
})
export class NavHeaderComponent implements OnInit {
  @ViewChild('snav') sidenav: MatSidenav;
  
  signalUser: SignalUser = new SignalUser();
  isExpanded = false;
  roles: string[];
  clienteDisplay: string = "Cargando...";
  public clientes: any = [];
  form: FormGroup;
  mobileQuery: MediaQueryList;
  userName: any;
  rolItem: string[] = [];
  isBlocked: boolean = true;
  isLoading: boolean = false;
  isEnlargedSideBar: boolean = false;
  closeTimeout: any;
  views: any = [];
  notificationList: NotificationDTO[] = [];
  public $isLocationSelected: Observable<boolean> = new Observable<boolean>();
  public $isRoutesSelected: Observable<boolean> = new Observable<boolean>();
  public $isGeofencesSelected: Observable<boolean> = new Observable<boolean>();

  public $rolItem: Observable<string[]> = new Observable<string[]>();
  public $clientes: Observable<any> = new Observable<any>();
  public $clienteDisplay: Observable<string> = new Observable<string>();
  public $views: Observable<string[]> = new Observable<string[]>();

  $pushedClassSelected: Observable<string> = new Observable<string>();
  isLocationSelected: boolean;
  isRoutesSelected: boolean;
  isGeofencesSelected: boolean;
  pushedClassSelected: string;

  private _mobileQueryListener: () => void;
  fillerNav = Array.from({ length: 50 }, (_, i) => `Nav Item ${i + 1}`);
  isMapix: boolean;
  
  subscription_SetClients: Subscription;
  subscription_GetAlarms: Subscription;
  subscription_isLocationSelected: Subscription;
  subscription_isRoutesSelected: Subscription;
  subscription_isGeofencesSelected: Subscription;
  subscription_pushedClassSelected: Subscription;
  subscription_rolItem: Subscription;
  subscription_clientes: Subscription;
  subscription_clienteDisplay: Subscription;
  subscription_views: Subscription;

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private authService: AuthService,
    private sessionService: SessionService,
    private router: Router,
    private callbackService: CallBackService,
    public permissionService: PermissionsService,
    private routerService: Router,
    public navHeaderService: NavHeaderService,
    public notificationService: NotificationService,
    public notifyService: SwalNotificationService,
    private alarmService: AlarmService,
    private signalRService: SignalRService,
    private signalUserService: SignalUserService,
    private tutorialService: TutorialService,
    private encriptionService: EncriptionService,
    private imageCacheService: ImageCacheService,
    private eRef: ElementRef,
    private dialog: MatDialog,
    private layerCatalogService: LayerService,
    private mapHelperService: MapHelperService,
    private controlPanelService: ControlPanelService
  ) {
    this.isLoading = false;
    this.mobileQuery = media.matchMedia("(min-width: 760px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.userName = localStorage.getItem("userName");
    setTimeout(() => {
      this.eventoDespuesDe12Horas();
    }, 12 * 60 * 60 * 1000);

    this.$isLocationSelected = this.navHeaderService.getIsLocationSelected();
    this.subscription_isLocationSelected = this.$isLocationSelected.subscribe((element) => {
      this.isLocationSelected = element;
    });

    this.$isRoutesSelected = this.navHeaderService.getIsRoutesSelected();
    this.subscription_isRoutesSelected = this.$isRoutesSelected.subscribe((element) => {
      this.isRoutesSelected = element;
    });

    this.$isGeofencesSelected = this.navHeaderService.getIsGeofencesSelected();
    this.subscription_isGeofencesSelected = this.$isGeofencesSelected.subscribe((element) => {
      this.isGeofencesSelected = element;
    });

    this.$pushedClassSelected = this.navHeaderService.getPushedClass();
    this.subscription_pushedClassSelected = this.$pushedClassSelected.subscribe((element) => {
      this.pushedClassSelected = element;
    });

    this.$rolItem = this.callbackService.getRolItem();
    this.subscription_rolItem = this.$rolItem.subscribe((element) => {
      this.rolItem = element;
      this.controlPanelService.rolItem = element;
    });

    this.$clientes = this.callbackService.getClientes();
    this.subscription_clientes = this.$clientes.subscribe((element) => {
      this.clientes = element;
    });

    this.$clienteDisplay = this.callbackService.getClienteDisplay();
    this.subscription_clienteDisplay = this.$clienteDisplay.subscribe((element) => {
      this.clienteDisplay = element;
    });

    this.$views = this.callbackService.getViews();
    this.subscription_views = this.$views.subscribe((element) => {
      this.views = element;
      
    });
  }

  async ngOnInit() {
    this.checkingURL();
    this.tutorialService.setupTours();
    this.mobileQuery.removeListener(this._mobileQueryListener);
    await this.CheckCallback();
    this.navHeaderService.CheckMapPaneles();
    //abre la conexion con el nuevo cliente si no existe una conexion activa (en caso de cambio de cliente)
    if (this.signalRService.signalConnection == null) {
      this.UnsubscribeSignalUser(this.signalUser);

       this.startHubConnection();
    }
    this.notificationService.getActiveNotificationsCount();
    this.notificationService.getNotifications(1);

    // setTimeout(() => {
    //   this.alarmService.checkAlarms(this.mobileQuery.matches);
    // }, 2000);
  }


  ngOnDestroy() {
    if (this.subscription_SetClients)
      this.subscription_SetClients.unsubscribe();
    if (this.subscription_GetAlarms)
      this.subscription_GetAlarms.unsubscribe();
  }

  onClickMenuButton(id) {
    //los if son para paneles del mapa, el else para las demas vistas
    console.log(id); 
    if (id == "locationsMap") {
      this.navHeaderService.setPushedClass();
      this.router.navigate(["/unifiedMap",],{queryParams:{ selectedPanel: 'locationsMap'}});
      this.navHeaderService.setIsLocationSelected(true);
    } else if (id == "routingMap") {
      this.navHeaderService.setPushedClass();
      this.router.navigate(["/unifiedMap",],{queryParams:{ selectedPanel: 'routingMap'}});
      this.navHeaderService.setIsRoutesSelected(true);
    } else if (id == "geofencesMap") {
      this.navHeaderService.setPushedClass();
      this.router.navigate(["/unifiedMap",],{queryParams:{ selectedPanel: 'geofencesMap'}});
      this.navHeaderService.setIsGeofencesSelected(true);
    } else {
      this.router.navigateByUrl("/" + id);
    }
    this.isEnlargedSideBar = false;

    if(!this.mobileQuery.matches){
      this.sidenav.close();
    }
  }

  // openNav() {
  //   this.isExpanded = true;
  // }
  // collapse() {
  //   this.isExpanded = false;
  // }

  private async CheckCallback() {
    //checa el callback y muestra la carga
    this.isLoading = true;
    await this.callbackService.isNeededCallback();
    this.isLoading = false;

    //realiza las views y dependiendo del número, redirige a la página de error
    this.views = this.encriptionService.DecryptViews();
    if (this.views.length == 0) {
      this.routerService.navigate(["/error"]);
    }else{
      // this.routerService.navigate(["/unifiedMap"]);
    }
  }

  checkingURL() {
    this.sessionService.CheckURLSource();
    this.isMapix = this.sessionService.isMapix;
  }

  async Logout() {
    this.UnsubscribeSignalUser(this.signalUser);
    this.imageCacheService.clearImageCache();
    this.dialog.closeAll();
    this.layerCatalogService.isExternalLayersVisible = false;
    this.layerCatalogService.isExternalLayersButtonDisabled = true;
    this.layerCatalogService.isInternalLayersVisible = false;
    this.layerCatalogService.isMapLayersVisible = false;
    this.mapHelperService.infoBoxClick.next(null);
    this.mapHelperService.mainSourceSubject.next(null);
    let resp = this.authService.Logout();
  }

  getClass(viewName, viewUri) {
    if (this.isLocationSelected && viewName == "locationsMap") {
      return "locationsMapImHere";
    } if (this.isRoutesSelected && viewName == "routingMap") {
      return "routingMapImHere";
    } if (this.isGeofencesSelected && viewName == "geofencesMap") {
      return "geofencesMapImHere";
    }
    // } else {
    //   var Pushedclass =
    //     this.router.url === "/" + viewUri ? viewUri + "ImHere" : "";
    //   return Pushedclass;
    // }
  }

  //Metodo para actualizar al cliente default despues de 20 horas
  async eventoDespuesDe12Horas() {
    console.log("onWindowSleep");
    this.UnsubscribeSignalUser(this.signalUser);
    let resp = this.authService.Logout();
  }

  async onChangeClient(event: any) {

    this.isLoading = true;
    var cliente = this.clientes.find(x => x.idCustomer == event.value);
    try {
      const updateClientIdPromise = firstValueFrom(
        this.authService.UpdateClientId(cliente).pipe(take(1))
      );
      // llama al callback con la promesa para hacer todas al mismo timpo, dentro se encargará de verificar si sí se actualiza
      const updateClientIdResult = await updateClientIdPromise;

      if (updateClientIdResult && updateClientIdResult.isSuccess){localStorage.setItem("ClienteSeleccionado", this.encriptionService.EncryptData(this.clientes.find((x) => x.idCustomer == event.value).customerName ));
        localStorage.setItem("ClienteSeleccionadoId", this.encriptionService.EncryptData(event.value));
        await this.callbackService.dataCallbackOneCall(false);
        this.callbackService.assignNavbarValues();
      }
    } catch (error) {
      this.clienteDisplay = this.encriptionService.DecryptData(localStorage.getItem("ClienteSeleccionado"));
      this.isLoading = false;
    } finally {
      this.clienteDisplay = this.encriptionService.DecryptData(localStorage.getItem("ClienteSeleccionado"));
      this.isLoading = false;
      location.reload();
    }


    // this.subscription_SetClients = this.authService.UpdateClientId(
    //   cliente
    // ).subscribe((data) => {
    //   if (data.isSuccess) {
    //     //cierra la conexion con el hub del cliente actual 
    //     this.closeHubConnection();
    //     localStorage.setItem("ClienteSeleccionado", this.encriptionService.EncryptData(this.clientes.find((x) => x.idCustomer == event.value).customerName ));
    //     localStorage.setItem("ClienteSeleccionadoId", this.encriptionService.EncryptData(event.value));
    //     const role = [];
    //     role.push(data.result);
    //     localStorage.setItem("userRol", JSON.stringify(role.map(role => this.encriptionService.EncryptData(role))));
    //     this.callbackService.setRolItem(data.result);
    //     localStorage.setItem("permissions", "");
    //     localStorage.setItem("listaCategorias", "");
    //     this.callbackService.isNeededCallback().then(data => {
    //       this.isLoading = false;
    //       location.reload();
    //     });
    //     // Recarga la página con la funcion para marcar que la recarga está ocurriendo
    //   } else {
    //     this.clienteDisplay = this.encriptionService.DecryptData(localStorage.getItem("ClienteSeleccionado"));
    //     this.isLoading = false;
    //   }
    // });
  }

  EnlargeOrCloseSideBar(){
    if(!this.mobileQuery.matches){
      this.sidenav.toggle();
    }else{
      this.isEnlargedSideBar = !this.isEnlargedSideBar;
    }
  }

  EnlargeSideBar(){
    if(!this.mobileQuery.matches){
      this.sidenav.toggle();
    }else{
      this.isEnlargedSideBar = true;
    }
  }
  
  CloseSideBar(event?: MouseEvent){
  this.closeTimeout = setTimeout(() => {
    const relatedTarget = event?.relatedTarget as Element | null;
    const activeTooltips = relatedTarget?.className?.toString().includes('mdc-tooltip') ?? false;
    
    if (activeTooltips) {
      return;
    }
    if(!this.mobileQuery.matches){
      this.sidenav.toggle();
    }else{
      this.isEnlargedSideBar = false;
    }
  }, 300);
}

StopCloseTimeout() {
  if (this.closeTimeout) {
    clearTimeout(this.closeTimeout);
    this.closeTimeout = null;
  }
}

// notificaciones ------------------------------

  toggleNotifications(): void {
    this.notificationService.toggleNotifications();
  }

  // fin de notificaciones ------------------------------

  ToggleAlarms() {
    this.alarmService.ToggleAlarms(this.mobileQuery.matches);
  }

  ResetTutorials() {
    var resp = this.notifyService.confirmMessage("Reactivar tutoriales","Se activara nuevamente el tutorial inicial, ¿Desea continuar?");
        resp.then((result) =>{
          if (result.isConfirmed) {
            localStorage.setItem("ShownTutorials", JSON.stringify([]));
            document.location.reload();
          }
        });
  }

  startHubConnection(){
    //Start Connection SignalR
    this.signalRService.startConnection();
    if (this.signalRService.ConnectionId != null) {
      this.SubscribeSignalUser(this.signalUser);
    }else{
      
      setTimeout(() => {
        this.SubscribeSignalUser(this.signalUser);
      }, 3000);
    }
  }

  closeHubConnection(){
    this.UnsubscribeSignalUser(this.signalUser);
    this.signalRService.endConnection();
  }


  SubscribeSignalUser(SignalUser: SignalUser) {
    //Subscribe to SignalClient
    SignalUser.ConnectionId = this.signalRService.ConnectionId;
    this.signalUserService.SubscribeGeneralSignalUserService(SignalUser);
    this.signalRService.ActivateListenerNewNotification();
  }

  UnsubscribeSignalUser(SignalUser: SignalUser) {
    //Unsubscribe to SignalClient
    SignalUser.ConnectionId = this.signalRService.ConnectionId;
    this.signalRService.ConnectionId = null;

    this.signalUserService.UnsubscribeSignalUserService();
  }
}
